// extracted by mini-css-extract-plugin
export var checkboxInputRow = "x_sn";
export var checkboxInputColumn = "x_sp";
export var inputOptionRow = "x_qq";
export var inputOptionColumn = "x_qr";